



















































import Vue from 'vue';
import { dateFormatYYYYMMDD, dateTransactionFormat } from '@/constants';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { ScheduledTransactionResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  dateFormatYYYYMMDD: string;
  dateTransactionFormat: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'CancelScheduledDeposit',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      dateFormatYYYYMMDD,
      dateTransactionFormat,
    };
  },
  computed: {
    transactions(): ScheduledTransactionResponseModel[] {
      return this.$store.getters.scheduledTransactions;
    },
    selectedTransaction(): ScheduledTransactionResponseModel {
      const filteredActivity = this.transactions.filter((activity) => {
        return (
          activity.scheduledDepositId.toString() ===
          this.params.transactionId.toString()
        );
      });
      return filteredActivity.length ? filteredActivity[0] : null;
    },
    selectedTransactionDescriptionProps(): any {
      if (!this.selectedTransaction) { return {}; }
      return {
        description: this.selectedTransaction.description,
        date: this.varReplaceDate,
        amount: this.varReplaceAmount,
      };
    },
    varReplaceDate(): string {
      if (!this.selectedTransaction) { return ''; }
      return this.$options.filters.moment(
        [this.selectedTransaction.pullDate, dateFormatYYYYMMDD],
        dateTransactionFormat,
      );
    },
    varReplaceAmount(): string {
      if (!this.selectedTransaction) { return ''; }
      return this.$options.filters.currency(
        this.selectedTransaction.amount,
      );
    },
  },
  methods: {
    cancelScheduledDeposit(): void {
      this.isLoading = true;
      this.$store
        .dispatch(
          'deleteScheduledDeposit',
          this.selectedTransaction.scheduledDepositId,
        )
        .then(() => {
          this.refreshTransactions();

          // GTM Event - Submit Direct Deposit
          window.dataLayer.push({
            event: 'terminateDeposit',
          });
        })
        .catch(() => {
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshTransactions(): void {
      this.$store
        .dispatch('getAccountTransactions', this.$route.params.id)
        .then(() => {
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'cancel-scheduled-deposit_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
